import { Feature, FeatureCollection, MultiPolygon, Polygon } from "geojson";

import { featureCollection, union } from "fond/turf";
import { isAnyPolygon } from "fond/types/geojson";

/** The polygons across every collection, ignoring features of any other geometry. */
export const selectPolygons = (collections: FeatureCollection[]): Feature<Polygon | MultiPolygon>[] =>
  collections.flatMap((collection) => collection.features.filter(isAnyPolygon));

/** A single boundary covering every given polygon, or null when there are none. */
export const toPolygonBoundary = (polygons: Feature<Polygon | MultiPolygon>[]): Feature<Polygon | MultiPolygon> | null => {
  if (polygons.length === 0) return null;
  if (polygons.length === 1) return polygons[0];

  return union(featureCollection(polygons));
};
